import { Button, Card, Col, Row, Tab, Tabs } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import type { ApiKeyType } from '../types';
import ESpinner from 'components/others/Spinner';
import ApiKeysForm from './ApiKeysForm';
import ApiKeysTable from './ApiKeysTable';
import useApiKeys from './model/useApiKeys';

const ApiKeys = () => {
    const { t } = useTranslation(['Settings', 'common']);
    const {
        tab,
        setTab,
        rows,
        rowsIn,
        rowsOut,
        isLoading,
        formIn,
        formOut,
        editingInId,
        editingOutId,
        savingType,
        getShowCreate,
        openCreateForm,
        setForm,
        resetForm,
        saveForm,
        startEdit,
        deleteRow,
        generateFormKey,
    } = useApiKeys();

    return (
        <Row>
            <Col sm={12}>
                <div className="w-100 d-md-flex pt-1 justify-content-between align-items-start mb-3 mb-md-2">
                    <div className="pb-1">
                        <h4 className="p-0 m-0">{t('apiKeys.title')}</h4>
                        <small className="text-muted">{t('apiKeys.subtitle')}</small>
                    </div>
                    <div className="page-toolbar-actions mt-2 mt-md-0">
                        <Button size="sm" variant="success" onClick={() => openCreateForm(tab)}>
                            <i className="bi bi-plus fs-14 me-1"></i>
                            {t('apiKeys.btnCreate')}
                        </Button>
                    </div>
                </div>

                {isLoading || !rows ? (
                    <Card>
                        <Card.Body>
                            <ESpinner />
                        </Card.Body>
                    </Card>
                ) : (
                    <Card>
                        <Card.Body>
                            <Tabs
                                activeKey={tab}
                                onSelect={(eventKey) => setTab((eventKey || 'in') as ApiKeyType)}
                                variant="underline"
                                className="mb-3 invoice-tab border-bottom"
                            >
                                <Tab eventKey="in" title={t('apiKeys.tabIn')}>
                                    <div className="pt-3">
                                        <ApiKeysForm
                                            type="in"
                                            form={formIn}
                                            editId={editingInId}
                                            showForm={getShowCreate('in') || !!editingInId}
                                            isSaving={savingType === 'in'}
                                            setForm={(form) => setForm('in', form)}
                                            onGenerateKey={() => generateFormKey('in')}
                                            onReset={() => resetForm('in')}
                                            onSave={() => saveForm('in')}
                                        />
                                        <ApiKeysTable type="in" data={rowsIn} onEdit={startEdit} onDelete={deleteRow} />
                                    </div>
                                </Tab>
                                <Tab eventKey="out" title={t('apiKeys.tabOut')}>
                                    <div className="pt-3">
                                        <ApiKeysForm
                                            type="out"
                                            form={formOut}
                                            editId={editingOutId}
                                            showForm={getShowCreate('out') || !!editingOutId}
                                            isSaving={savingType === 'out'}
                                            setForm={(form) => setForm('out', form)}
                                            onGenerateKey={() => generateFormKey('out')}
                                            onReset={() => resetForm('out')}
                                            onSave={() => saveForm('out')}
                                        />
                                        <ApiKeysTable type="out" data={rowsOut} onEdit={startEdit} onDelete={deleteRow} />
                                    </div>
                                </Tab>
                            </Tabs>
                        </Card.Body>
                    </Card>
                )}
            </Col>
        </Row>
    );
};

export default ApiKeys;
